module.exports = __webpack_public_path__ + "img/032-storm-12.2df6cc9f.svg";